module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_library.js
// module id = 13
// module chunks = 0 1